import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdRuleSetResultByRuleSetResultIdOptions } from '@onefootprint/fetch-dashboard';
import type { RuleAction } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
type UseEntityRuleSetResultProps = {
  entityId: string;
  ruleSetResultId?: string;
};
const useEntityRuleSetResult = t0 => {
  const $ = _c(6);
  const {
    entityId,
    ruleSetResultId
  } = t0;
  const t1 = ruleSetResultId ?? "";
  let t2;
  if ($[0] !== entityId || $[1] !== t1) {
    t2 = getEntitiesByFpIdRuleSetResultByRuleSetResultIdOptions({
      path: {
        fpId: entityId,
        ruleSetResultId: t1
      }
    });
    $[0] = entityId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = Boolean(entityId) && Boolean(ruleSetResultId);
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = {
      ...t2,
      enabled: t3,
      select: _temp
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return useQuery(t4);
};
export default useEntityRuleSetResult;
function _temp(response) {
  return {
    ...response,
    actionTriggered: response.actionTriggered ? response.actionTriggered : "pass" as RuleAction
  };
}